import CenterLayout from "@/layouts/center";

export default [
	{
	    path: "/pdf",
	    component: CenterLayout,
	    children: [
	      {
	        path: "orden",
	        name: "pdf.orden",
	        component: () =>
	          import("@/views/pdf/orden/index.vue")
	      },
	    ]
	}
]